import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserNetworkState } from 'user/model/user-network.state';
import { UserNetworkType } from 'user/model/user-network.type';

import { ApiQuery } from '../../../../common/model/api.query';

export interface UserNetworkStateParams {
	readonly type: UserNetworkType;
}

@Injectable({ providedIn: 'root' })
export class UserNetworkStateApiQuery extends ApiQuery<
	UserNetworkState,
	UserNetworkStateParams
> {
	client = 'iam';
	document = gql`
		query UserNetworkState($type: UserNetworkType!) {
			userNetworkState(type: $type)
		}
	`;
	method = 'userNetworkState';
}
